export enum GiveType {
  Monetary = 1,
  InKind = 2,
  FeeForService = 3
}